// GLOBAL CONFIG THAT LOADS ENVIRONMENT VARIABLES INTO REACT

const environment = () => {
  try {
    if (window.__RUNTIME_CONFIG__) {
      return window.__RUNTIME_CONFIG__;
    }

    if (process.env) {
      return process.env;
    }
  } catch (err) {
    console.error(err);
    return process.env;
  }
};

module.exports = {
  environment: environment()
};
